import { useEffect } from 'react';

const useOutsideClick = (ref: React.RefObject<HTMLElement>, callback: () => void): void => {
  const handleClickOutside = (e: Event): void => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };

  const handleCloseModal = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      callback();
    }
  };

  useEffect(() => {
    const handleClickOutsideWithStopPropagation = (e: MouseEvent): void => {
      // 수정: 클릭된 요소가 버튼인 경우에는 이벤트 전파를 막음
      const targetNode = e.target as Node | null;
      if ((targetNode as Element).tagName === 'BUTTON') {
        return;
      }

      handleClickOutside(e);
    };

    const handleEscapeKeyWithStopPropagation = (e: KeyboardEvent): void => {
      e.stopPropagation();
      handleCloseModal(e);
    };

    document.addEventListener('click', handleClickOutsideWithStopPropagation, true);
    document.addEventListener('keydown', handleEscapeKeyWithStopPropagation, true);

    return () => {
      document.removeEventListener('click', handleClickOutsideWithStopPropagation, true);
      document.removeEventListener('keydown', handleEscapeKeyWithStopPropagation, true);
    };
  }, [ref, callback]);
};

export default useOutsideClick;
